import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'

const LazyPasskeyManagementPage = lazy(() =>
  import('../pages/PasskeyManagement/PasskeyManagementPage').then((module) => ({
    default: module.PasskeyManagementPage,
  })),
)

export const PasskeyManagementRoute: FC = (): ReactElement => {
  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyPasskeyManagementPage />
    </Suspense>
  )
}
